import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  PoiSchema,
  CreatePoiBodySchema,
  PatchPoiBodySchema,
  PoiListQuerySchema,
  NearbyPoiSchema,
  PoiCategorySchema,
  PoiStatsSchema,
  PoiImportTriggerResponseSchema,
  PoiImportStatusSchema,
} from '../schemas/poi.js';
import { MapPinsResponseSchema } from '../schemas/map-pins.js';

export const pois = {
  list: endpoint('GET', '/pois', PoiListQuerySchema, z.array(PoiSchema)),

  getById: endpoint('GET', '/pois/:id', z.object({ id: z.string().uuid() }), PoiSchema),

  create: endpoint('POST', '/pois', CreatePoiBodySchema, PoiSchema),

  delete: endpoint('DELETE', '/pois/:id', z.object({ id: z.string().uuid() }), z.void()),

  patch: endpoint(
    'PATCH',
    '/pois/:id',
    z.object({ id: z.string().uuid() }).merge(PatchPoiBodySchema),
    PoiSchema,
  ),

  nearbyPois: endpoint(
    'GET',
    '/media-units/:id/nearby-pois',
    z.object({
      id: z.coerce.number().int().positive(),
      limit: z.coerce.number().int().positive().optional(),
    }),
    z.array(NearbyPoiSchema),
  ),

  mediaUnitsWithin: endpoint(
    'GET',
    '/pois/:id/media-units-within',
    z.object({
      id: z.string().uuid(),
      radius_m: z.coerce.number().positive(),
    }),
    MapPinsResponseSchema,
  ),

  categories: endpoint('GET', '/poi-categories', z.object({}), z.array(PoiCategorySchema)),

  stats: endpoint('GET', '/pois/stats', z.object({}), PoiStatsSchema),

  triggerImport: endpoint(
    'POST',
    '/pois/import/trigger',
    z.object({}),
    PoiImportTriggerResponseSchema,
  ),

  importStatus: endpoint('GET', '/pois/import/status', z.object({}), PoiImportStatusSchema),
};
